import { useThemeStore, type Theme } from "@/stores/themeStore";

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);
  return { theme, setTheme } satisfies { theme: Theme; setTheme: (theme: Theme) => void };
}
